const business_type_service = 0;
const business_type_product = 1;

export default {
  business_type_service: business_type_service,
  business_type_product: business_type_product,
};
